import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconPasteReferences: React.FC<IconProps> = ({
    width = 18,
    height = 18,
    color = '#DFEAFF',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 18 20"
            fill="none"
        >
            <path
                d="M14.8602 12.9293H11.9304V12.3433C11.9304 11.611 11.4801 10.9821 10.842 10.7182C11.0639 9.38688 11.4198 8.13988 12.5659 6.12981C12.9168 5.51438 13.1022 4.81274 13.1022 4.1007C13.1022 1.83207 11.2603 -0.0169916 8.96137 0.000117786C6.92066 0.0153131 5.3173 1.5043 4.97519 3.29859C4.76352 4.40875 4.99492 5.52242 5.62695 6.43445C6.49375 7.68543 6.91137 9.2325 7.15898 10.7182C6.5209 10.9821 6.07062 11.611 6.07062 12.3433V12.9293H3.14078C1.52527 12.9293 0.210938 14.2436 0.210938 15.8591V17.0702C0.210938 17.3938 0.473281 17.6561 0.796914 17.6561H1.38289V18.2421C1.38289 19.2114 2.17148 20 3.14078 20H14.8602C15.8295 20 16.6181 19.2114 16.6181 18.2421V17.6561H17.2041C17.5277 17.6561 17.79 17.3938 17.79 17.0702V15.8591C17.79 14.2436 16.4757 12.9293 14.8602 12.9293ZM6.59027 5.76703C6.13883 5.11551 5.9741 4.31684 6.12641 3.51813C6.36508 2.26649 7.51395 1.15367 9.03953 1.17051C10.6458 1.18824 11.9303 2.50406 11.9303 4.1007C11.9303 4.60953 11.798 5.11043 11.5478 5.54934C10.3239 7.69602 9.93121 9.05438 9.67598 10.5854H8.32488C8.0427 8.89129 7.5791 7.1941 6.59027 5.76703ZM10.7584 12.3433V12.9293H7.24258V12.3433C7.24258 12.0202 7.50543 11.7573 7.82855 11.7573H10.1724C10.4955 11.7574 10.7584 12.0202 10.7584 12.3433ZM15.4462 18.2421C15.4462 18.5652 15.1833 18.8281 14.8602 18.8281H3.14082C2.81773 18.8281 2.55484 18.5652 2.55484 18.2421V17.6561H15.4462V18.2421ZM16.6181 16.4842C15.9424 16.4842 2.62254 16.4842 1.38293 16.4842V15.8591C1.38293 14.8898 2.17152 14.1013 3.14082 14.1013C3.42754 14.1013 13.5089 14.1013 14.8602 14.1013C15.8295 14.1013 16.6181 14.8898 16.6181 15.8591V16.4842Z"
                fill={color}
            />
        </svg>
    );
};

export default IconPasteReferences;
